import { useTabs } from "../store/tabs.js";

/**
 * Rename one tab in place. `AppLayout` injects the path-keyed form of this into
 * feature packages via the `ShellBridge` (`setTabLabelForPath`) so a workspace
 * can set its OWN tab's label to the loaded entity's title (e.g. a SOLVE
 * title) without importing the tab store.
 *
 * No-ops when the tab is gone or the label is already current, so a workspace
 * can call it freely from a render effect without churning state.
 */
export function setTabLabel(id: string, label: string): void {
  const { tabs, replaceTab } = useTabs.getState();
  const tab = tabs.find((t) => t.id === id);
  if (!tab || tab.label === label) return;
  replaceTab(id, { ...tab, label });
}

/**
 * Rename the active tab in place. Kept on the `ShellBridge` for callers that
 * mean "whatever is active"; a workspace labelling itself must use
 * `setTabLabelForPath`, because the active tab can already be another one when
 * its effect runs.
 */
export function setActiveTabLabel(label: string): void {
  const { activeTabId } = useTabs.getState();
  if (activeTabId) setTabLabel(activeTabId, label);
}
